// extracted by mini-css-extract-plugin
export default {"redirectPlaceholder":"LandingPage_redirectPlaceholder__qU52b"};